/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Buttons_Downloadcsv1Inputs */

const id_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduh sebagai CSV`)
};

const ms_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat turun sebagai CSV`)
};

const da_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download som CSV`)
};

const de_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als CSV herunterladen`)
};

const en_us2_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download as CSV`)
};

const es_es2_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar como CSV`)
};

const es_mx2_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar como CSV`)
};

const fil_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-download bilang CSV`)
};

const fr_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger en CSV`)
};

const it_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica come CSV`)
};

const hu_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letöltés CSV-ként`)
};

const nl_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloaden als CSV`)
};

const no_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last ned som CSV`)
};

const pl_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobierz jako CSV`)
};

const pt_br2_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixar como CSV`)
};

const pt_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregar como CSV`)
};

const ro_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarcă ca CSV`)
};

const fi_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa CSV-muodossa`)
};

const sv_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda ner som CSV`)
};

const vi_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải xuống dạng CSV`)
};

const tr_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV Olarak İndir`)
};

const cs_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáhnout jako CSV`)
};

const bg_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изтегляне като CSV`)
};

const ru_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать как CSV`)
};

const uk_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажити як CSV`)
};

const ar_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنزيل بصيغة CSV`)
};

const hi_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV के रूप में डाउनलोड करें`)
};

const th_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดาวน์โหลดเป็น CSV`)
};

const ja_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV としてダウンロード`)
};

const zh_cn2_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载为CSV`)
};

const zh_hant1_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下載為CSV`)
};

const ko_freebies_buttons_downloadcsv1 = /** @type {(inputs: Freebies_Buttons_Downloadcsv1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV 다운로드`)
};

/**
* | output |
* | --- |
* | "Download as CSV" |
*
* @param {Freebies_Buttons_Downloadcsv1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_buttons_downloadcsv1 = /** @type {((inputs?: Freebies_Buttons_Downloadcsv1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Buttons_Downloadcsv1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_buttons_downloadcsv1(inputs)
	if (locale === "ms") return ms_freebies_buttons_downloadcsv1(inputs)
	if (locale === "da") return da_freebies_buttons_downloadcsv1(inputs)
	if (locale === "de") return de_freebies_buttons_downloadcsv1(inputs)
	if (locale === "en-US") return en_us2_freebies_buttons_downloadcsv1(inputs)
	if (locale === "es-ES") return es_es2_freebies_buttons_downloadcsv1(inputs)
	if (locale === "es-MX") return es_mx2_freebies_buttons_downloadcsv1(inputs)
	if (locale === "fil") return fil_freebies_buttons_downloadcsv1(inputs)
	if (locale === "fr") return fr_freebies_buttons_downloadcsv1(inputs)
	if (locale === "it") return it_freebies_buttons_downloadcsv1(inputs)
	if (locale === "hu") return hu_freebies_buttons_downloadcsv1(inputs)
	if (locale === "nl") return nl_freebies_buttons_downloadcsv1(inputs)
	if (locale === "no") return no_freebies_buttons_downloadcsv1(inputs)
	if (locale === "pl") return pl_freebies_buttons_downloadcsv1(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_buttons_downloadcsv1(inputs)
	if (locale === "pt") return pt_freebies_buttons_downloadcsv1(inputs)
	if (locale === "ro") return ro_freebies_buttons_downloadcsv1(inputs)
	if (locale === "fi") return fi_freebies_buttons_downloadcsv1(inputs)
	if (locale === "sv") return sv_freebies_buttons_downloadcsv1(inputs)
	if (locale === "vi") return vi_freebies_buttons_downloadcsv1(inputs)
	if (locale === "tr") return tr_freebies_buttons_downloadcsv1(inputs)
	if (locale === "cs") return cs_freebies_buttons_downloadcsv1(inputs)
	if (locale === "bg") return bg_freebies_buttons_downloadcsv1(inputs)
	if (locale === "ru") return ru_freebies_buttons_downloadcsv1(inputs)
	if (locale === "uk") return uk_freebies_buttons_downloadcsv1(inputs)
	if (locale === "ar") return ar_freebies_buttons_downloadcsv1(inputs)
	if (locale === "hi") return hi_freebies_buttons_downloadcsv1(inputs)
	if (locale === "th") return th_freebies_buttons_downloadcsv1(inputs)
	if (locale === "ja") return ja_freebies_buttons_downloadcsv1(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_buttons_downloadcsv1(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_buttons_downloadcsv1(inputs)
	return ko_freebies_buttons_downloadcsv1(inputs)
});
export { freebies_buttons_downloadcsv1 as "freebies.buttons.downloadCsv" }